import apiClient from "../../utils/apiClient";

const LOGIN = "/login";

const login = (data) => {
  const url = `${LOGIN}`;
  return apiClient.post(url, data);
};

const loginLinkRequest = (data) => apiClient.post('/auth/magic/login', data);

const exchangeMagic = (payload) => apiClient.post('/auth/magic/exchange', payload);

export const loginService = {
  login,
  loginLinkRequest,
  exchangeMagic
};
